module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5_2.912ad675.png";